// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-containers-Profile-DetachSocial-styles--profileItem--CEQYC {
  margin-left: 0;
  margin-right: 0;
  padding: 0 0 20px;
}

.src-containers-Profile-DetachSocial-styles--profileItemContent--YTNXD {
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/containers/Profile/DetachSocial/styles.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".profileItem {\n  margin-left: 0;\n  margin-right: 0;\n  padding: 0 0 20px;\n}\n\n.profileItemContent {\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profileItem": `src-containers-Profile-DetachSocial-styles--profileItem--CEQYC`,
	"profileItemContent": `src-containers-Profile-DetachSocial-styles--profileItemContent--YTNXD`
};
module.exports = ___CSS_LOADER_EXPORT___;
